import React from "react";

export default function CapterraLeadConversion() {
  return <img src="https://ct.capterra.com/capterra_tracker.gif?vid=2131394&vkey=356381ebb81b1185c19709aa05171b8b" />;
}
